import type Locale from 'date-fns';
import { enUS as enLocale, es as esLocale } from 'date-fns/locale';

export const DEFAULT_LANGUAGE = 'EN';

export const LocaleMap: Record<string, Locale> = {
  EN: enLocale,
  ES: esLocale,
};
